import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowMicroNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_237_15038",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 10,
		height: 10,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 10,
			height: 10,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_237_15038)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1 5H9M9 5L5 1M9 5L5 9",
			stroke: "#DFCBF5",
			strokeOpacity: .7
		})
	})]
});
export default SvgArrowMicroNew;
